import { FC } from 'react';
import {
  MINUTES_SIGN,
  PERCENTAGE_SIGN,
  STATISTICS_WITH_MINUTES_SIGN,
  STATISTICS_WITH_PERCENTAGE_SIGN,
} from '../../../../constants/h2hStatistics';
import { styled } from '../../../../theme/stitches.config';
import { SMPFlex, SMPText } from '../../../index';

export interface IComparisonRowProps {
  valueOne: number;
  valueTwo: number;
  label: string;
  name?: string;
  takeLowerValue?: boolean;
}

export const ComparisonRow: FC<IComparisonRowProps> = ({ valueOne, valueTwo, label, name, takeLowerValue }) => {
  const highlightFirstValue = takeLowerValue ? valueOne < valueTwo : valueOne > valueTwo;
  const highlightSecondValue = takeLowerValue ? valueTwo < valueOne : valueTwo > valueOne;

  const calculatedFullValue = valueOne + valueTwo;
  const percentageA = calculatedFullValue > 0 ? (valueOne / calculatedFullValue) * 100 : 0;
  const percentageB = calculatedFullValue > 0 ? (valueTwo / calculatedFullValue) * 100 : 0;

  const sign = name
    ? STATISTICS_WITH_PERCENTAGE_SIGN.includes(name)
      ? PERCENTAGE_SIGN
      : STATISTICS_WITH_MINUTES_SIGN.includes(name)
      ? MINUTES_SIGN
      : ''
    : '';

  return (
    <SMPFlex direction='column' css={{ bc: '$sportEntityContainerPrimaryBgColor', pb: '$3' }}>
      <SMPFlex justify='spaceBetween' css={{ mb: '$2', width: '100%' }}>
        <SMPText
          size='3'
          weight={highlightFirstValue ? '700' : '400'}
          css={{ color: highlightFirstValue ? '$progressHighlightedColor' : '$progressTextColor' }}
        >
          {valueOne + sign}
        </SMPText>
        <SMPText size='3' variant='contrast'>
          {label}
        </SMPText>
        <SMPText
          size='3'
          weight={highlightSecondValue ? '700' : '400'}
          css={{ color: highlightSecondValue ? '$progressHighlightedColor' : '$progressTextColor' }}
        >
          {valueTwo + sign}
        </SMPText>
      </SMPFlex>
      <SMPFlex css={{ bc: '$progressContainerBgColor', height: '$2', br: 25 }}>
        <Progressbar>
          <ProgressbarValue
            css={{
              bc: '$progressOneBgColor',
              right: 0,
              width: percentageA + '%',
            }}
          />
        </Progressbar>
        <Delimiter />
        <Progressbar>
          <ProgressbarValue
            css={{
              bc: '$progressTwoBgColor',
              width: percentageB + '%',
            }}
          ></ProgressbarValue>
        </Progressbar>
      </SMPFlex>
    </SMPFlex>
  );
};

const Progressbar = styled('div', {
  position: 'relative',
  width: 'calc(50% - 1px)',
  height: '100%',
});

const ProgressbarValue = styled('div', {
  position: 'absolute',
  height: '100%',
  br: 25,
});

const Delimiter = styled('div', {
  width: 4,
});
